  <form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [formGroup]="mainformGroup" [nzLayout]="'vertical'">
    <nz-form-item *ngIf="!field.hidden" [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label *ngIf="!field.noLabel" [nzFor]="fieldNew" [nzRequired]="field.required">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control  [nzValidatingTip]="field.tooltip" nzHasFeedback>
             <nz-switch [formControlName]="fieldNew" [nzSize]="field.size == null? 'default': field.size" [nzDisabled]="field.isDisabled"></nz-switch>
        </nz-form-control>
    </nz-form-item>
</form>